module.exports = __webpack_public_path__ + "media/uff.055cb4bc.wav";